import GlobalStoreService from "./global-store.service";
import UtilService from "./util.service";
import BotType from "../enums/BotType";

class DBReadWriteService {

    db_read_offset = 0;
    db_write_queue = [];
    //write status returned in write to db callback
    dbWriteStatus = true;
    messagesSentToBeWritten = [];
    //write callback returned or not -- this is independent of the status that is returned in the write callback
    writeCallbackReturned = true;
    readCallbackReturned = true;

    writeMessagesToDBQueue(new_messages) {
        //check if new app context
        if (window.MyAirtelChatAppReact && GlobalStoreService.get("currentBotType") !== BotType.PAYMENTS_BANK) {
            //filter the messages not to be written to DB for n messages method
            new_messages = new_messages.filter(message => !message.notToBeWrittenToDB)

            let messags_to_write = []
            new_messages.map(message => {
                messags_to_write.push(privateMethods.createDBMessageWriteObject(message))
            })
            // for n messages to be written
            if (messags_to_write && messags_to_write.length > 0) {
                this.db_write_queue = [...this.db_write_queue, ...messags_to_write];
                //call writeToDB whenever messages are required to be sent to DB
                privateMethods.writeToDB();
            }
        }
    }

    popMessageFromWriteNewMessageQueue() {
        this.new_messages_to_write_to_queue.pop();
    }

    setDBReadOffset(offset) {
        this.db_read_offset = offset;
    }

    readFromDB() {
        if (window.MyAirtelChatAppReact) {
            if (window.MyAirtelChatAppReact.readMessageWith) {

                if (this.db_read_offset !== -1 && this.readCallbackReturned) {
                    this.readCallbackReturned = false;
                    window.MyAirtelChatAppReact.readMessageWith(this.db_read_offset, "", "readReturnFunction");
                }
            }
            else {
                //do nothing
            }
        }
    }

    handleReadReturn(response) {

        let data = response && response.data ? response.data : [];
        if (data && data.length > 0) {
            data.map(message_obj => { message_obj.content = privateMethods.decodeContentString(message_obj.content) })
            //filter if content field is undefined
            data = data.filter(message_obj => message_obj.content)
        }

        if (response && response.offset) {
            //set db read offset that was received
            this.db_read_offset = response.offset;
        }
        if (response) {
            window.ourComponent.readReturnMethod(data, response.offset);
        }
        this.readCallbackReturned = true;

    }

    handleWriteReturn(response) {
        //set the db write status
        this.dbWriteStatus = response.status ? true : false;
        if (response.status) {
            // if db write status is true filter the db write queue and delete the messages that were written to db
            this.db_write_queue = this.db_write_queue.filter(queue_elem => !this.messagesSentToBeWritten.includes(queue_elem.timestamp))
        }
        // set the write callback returned to true
        this.writeCallbackReturned = true;
    }

    setMessagesSentToBeWritten(message_array) {

        let array_sent = [];

        message_array.map(message => array_sent.push(message.timestamp))

        this.messagesSentToBeWritten = array_sent;
    }

}

var dbReadWriteService = new DBReadWriteService();

export default dbReadWriteService;

const privateMethods = {

    createDBMessageWriteObject(message_content) {
        if (message_content && (!message_content.messageTime || (message_content.messageTime && !message_content.messageTime.timestamp))) {
            message_content.messageTime = UtilService.getCurrentTime()
        }

        return {
            content: this.encodeContentString(JSON.stringify(message_content)),
            serial_id: 'abcd',
            timestamp: (message_content.messageTime && message_content.messageTime.timestamp) || UtilService.getCurrentTime().timestamp,
            session_id: 'abc123',
            si_number: GlobalStoreService.get('currentNumber') ? GlobalStoreService.get('currentNumber') :
                GlobalStoreService.get('primaryNumber') ? GlobalStoreService.get('primaryNumber') :
                    ""
        }
    },
    encodeContentString(str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1);
            }));
    },

    decodeContentString(str) {
        let decodedstr;
        try {
            decodedstr = decodeURIComponent(atob(str).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        }
        catch (e) {
            decodedstr = undefined
        }
        return decodedstr

    },

    writeToDB() {
        let message_array = []
        if (dbReadWriteService.db_write_queue) {
            message_array = dbReadWriteService.db_write_queue;
        }
        //if db write callbackreturned for previous calls , call fir next messages in queue
        if (message_array.length > 0 && dbReadWriteService.writeCallbackReturned) {
            //set the messages that are to be sent to bw written 
            dbReadWriteService.setMessagesSentToBeWritten(message_array)

            let send_object = { data: message_array }
            let message_arr_str = JSON.stringify(send_object)

            if (window.MyAirtelChatAppReact) {
                if (window.MyAirtelChatAppReact.writeMessageFor) {
                    //set writecallback returned to false just before calling writemessagefor function
                    dbReadWriteService.writeCallbackReturned = false;
                    window.MyAirtelChatAppReact.writeMessageFor(message_arr_str, "writeReturnFunction")
                }
                else {
                    //do nothing
                }
            }
        }
    }
}



window.readReturnFunction = (response) => {
    setTimeout(() => {
        try {
            response = atob(response);
            response = JSON.parse(response);
        }
        catch (e) {
            console.log(e);
        }
        dbReadWriteService.handleReadReturn(response)
    }, 0);
}

window.writeReturnFunction = (response) => {

    try {
        response = atob(response);
        response = JSON.parse(response);

    }
    catch (e) {
        console.log(e)
    }
    dbReadWriteService.handleWriteReturn(response)
}


// WEBPACK FOOTER //
// ./src/services/db-read-write.service.js